import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { IssueLabel } from '../../../components/entities/IssueLabel'
import { RegisteredIntegerField } from '../../../components/fields/NumericField'
import { RegisteredTextField } from '../../../components/fields/TextField'
import { ConvertibleLabel } from '../../../components/entities/ConvertibleLabel'
import { WarrantEntity } from 'types/WarrantEntity'
import { IssueEntity } from 'types/IssueEntity'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { FormOrigin } from '../types/FormWarrantEntity'
import { useTranslation } from 'react-i18next'

function WarrantOriginDialog({
    warrant,
    entity,
    open,
    setOpen,
    addIssueLink,
}: {
    addIssueLink: (origin: FormOrigin) => void
    entity: IssueEntity | ConvertibleEntity | null
    open: boolean
    setOpen: (v: boolean) => void
    warrant: WarrantEntity
}) {
    const { t } = useTranslation()
    const formMethods = useForm({
        defaultValues: {
            warrantId: warrant.id,
            issueId: entity && 'type' in entity ? entity?.id : null,
            convertibleId: entity && !('type' in entity) ? entity?.id : null,
            warrantsPerUnit: null,
            numberOfWarrants: null,
            externalComment: null,
        },
    })
    const handleLinkIssue = async () => {
        const data = formMethods.getValues()
        const { warrantsPerUnit, numberOfWarrants, externalComment } = data
        const origin = {
            issueId: entity && 'type' in entity ? entity?.id : null,
            convertibleId: entity && !('type' in entity) ? entity?.id : null,
            warrantId: warrant.id,
            warrantsPerUnit,
            numberOfWarrants,
            externalComment,
        }
        addIssueLink(origin)
        setOpen(false)
        formMethods.reset()
    }

    const originType = entity ? ('type' in entity ? 'emission' : 'konvertibel') : 'utan emission'

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <FormProvider {...formMethods}>
                <DialogTitle>Koppla {originType}</DialogTitle>
                <DialogContent>
                    <Stack spacing={2}>
                        <Typography variant='body1'>
                            {entity && 'type' in entity && <IssueLabel issue={entity} />}
                            {entity && !('type' in entity) && <ConvertibleLabel convertible={entity} />}
                            {!entity && 'Ursprung utan emission'}
                        </Typography>
                        {entity && 'type' in entity && ['Rights issue', 'IPO'].includes(entity.type) && (
                            <RegisteredIntegerField
                                name='warrantsPerUnit'
                                label={t('entities.warrant.fields.warrantsPerUnit')}
                                fullWidth
                            />
                        )}
                        <RegisteredIntegerField
                            name='numberOfWarrants'
                            label={t('entities.warrant.plural')}
                            allowNegative
                            fullWidth
                        />
                        {!entity && (
                            <RegisteredTextField name='externalComment' label='Kommentar' fullWidth multiline />
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Stäng</Button>
                    <Button onClick={handleLinkIssue}>Registrera ursprung</Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default WarrantOriginDialog
